import React from 'react'
import {CustomerManagerContextProvider} from './../context/CustomerManagerContext'
import CustomerManagerPage from './CustomerManagerPage'

function CustomerManagerContainer(props) {
    const {match, location} = props
    const {search} = location
    const name = search ? Object.fromEntries(new URLSearchParams(search)) : ""
    const listCusID = match.params.id

    return <section className="ListCustomersContainer">
        <CustomerManagerContextProvider listCusID={listCusID}>
            <CustomerManagerPage listName={name}/>
        </CustomerManagerContextProvider>
    </section>
}

export default CustomerManagerContainer
